import { render, staticRenderFns } from "./ContratoDetalhar.vue?vue&type=template&id=235eec76&"
import script from "./ContratoDetalhar.vue?vue&type=script&lang=js&"
export * from "./ContratoDetalhar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports